export const COLORS = {
  primary: '#0a2540',
  accent: '#e63027',
  accent2: '#f4a623',
  light: '#f7f9fc',
  white: '#ffffff',
  gray: '#6b7280',
  border: '#e2e8f0',
  darkBg: '#060f1f',
} as const;

// ─── Real Contact Details ─────────────────────────────────────────────────────
export const CONTACT = {
  phone1: '+91 9319299973',
  phone2: '+91 9319299974',
  whatsapp: '919319299974',
  email: 'info@devbhoomilabels.com',
  address: 'Mandakini Vihar, Balaji Arcade - Shop No. 1, Kandoli Road, Sahastradhara Rd, Dehradun, Uttarakhand 248001',
  city: 'Dehradun, Uttarakhand',
  mapLink: 'https://maps.google.com/?q=Mandakini+Vihar+Balaji+Arcade+Dehradun',
} as const;

export const WHATSAPP_LINK = `https://wa.me/${CONTACT.whatsapp}`;

// ─── Images ───────────────────────────────────────────────────────────────────
// Every image is directly relevant to DevBhoomi Labels: barcode labels,
// thermal printers, scanners, TTR ribbons, POS systems and their use in
// specific industries — nothing generic or unrelated.
export const IMG = {

  // ── Hero section (800×600 — object-fit:cover at 168px / 348px) ──
  heroPrinter: 'https://plus.unsplash.com/premium_photo-1661933130869-eba2d7e28332?w=500&auto=format&fit=crop&q=60',
  heroLabels: 'https://images.unsplash.com/photo-1771848194199-873beaa7c1dc?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  heroPOS: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&h=600&fit=crop&q=80',

  // ── Product cards (600×400 — object-fit:cover at 200px) ──
  barcodeLabels: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=400&fit=crop&q=80',
  ttrRibbons: 'https://images.unsplash.com/photo-1612198188060-c7c2a3b66eae?w=600&h=400&fit=crop&q=80',
  printers: 'https://images.unsplash.com/photo-1544725176-7c40e5a71c5e?w=600&h=400&fit=crop&q=80',
  scanners: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=600&h=400&fit=crop&q=80',
  jewelleryLabels: 'https://images.unsplash.com/photo-1611652022419-a9419f74343d?w=600&h=400&fit=crop&q=80',
  taffetaLabels: 'https://images.unsplash.com/photo-1558769132-cb1aea458c5e?w=600&h=400&fit=crop&q=80',
  retailPOS: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&h=400&fit=crop&q=80',

  // ── Industry cards (800×400 — object-fit:cover at 140px) ──
  // Each image shows barcode/label usage in that specific industry sector.
  manufacturing: 'https://images.unsplash.com/photo-1553413077-190dd305871c?w=800&h=400&fit=crop&q=80',
  retail: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&h=400&fit=crop&q=80',
  logistics: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800&h=400&fit=crop&q=80',
  healthcare: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=800&h=400&fit=crop&q=80',
  food: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=400&fit=crop&q=80',
  pharma: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=800&h=400&fit=crop&q=80',
  ecommerce: 'https://images.unsplash.com/photo-1601598851547-4302969d0614?w=800&h=400&fit=crop&q=80',
  education: 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=800&h=400&fit=crop&q=80',
  office: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=800&h=400&fit=crop&q=80',
  transport: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800&h=400&fit=crop&q=80',
  jewellery: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=800&h=400&fit=crop&q=80',
  garments: 'https://images.unsplash.com/photo-1558769132-cb1aea458c5e?w=800&h=400&fit=crop&q=80',
  electronics: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=800&h=400&fit=crop&q=80',
  hospitality: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&h=400&fit=crop&q=80',
  construction: 'https://images.unsplash.com/photo-1553413077-190dd305871c?w=800&h=400&fit=crop&q=80',
  agriculture: 'https://images.unsplash.com/photo-1601598851547-4302969d0614?w=800&h=400&fit=crop&q=80',

  // ── Service cards (900×500 — object-fit:cover at 230px) ──
  amc: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=900&h=500&fit=crop&q=80',
  support: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=900&h=500&fit=crop&q=80',

  // ── AMC plan cards (500×300 — object-fit:cover at 130px) ──
  planBasic: 'https://images.unsplash.com/photo-1544725176-7c40e5a71c5e?w=500&h=300&fit=crop&q=80',
  planStandard: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=500&h=300&fit=crop&q=80',
  planEnterprise: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=500&h=300&fit=crop&q=80',

  // ── About / Company (800×600 for main; 500×350 for value cards) ──
  officeImg: 'https://images.unsplash.com/photo-1612198188060-c7c2a3b66eae?w=800&h=600&fit=crop&q=80',
  quality: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=500&h=350&fit=crop&q=80',
  customer: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=500&h=350&fit=crop&q=80',
  quickSupp: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=500&h=350&fit=crop&q=80',

  // ── Software section cards (800×500 — object-fit:cover at 220px) ──
  bartender: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=500&fit=crop&q=80',
  zebraDesign: 'https://images.unsplash.com/photo-1544725176-7c40e5a71c5e?w=800&h=500&fit=crop&q=80',
  posSoftware: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&h=500&fit=crop&q=80',
  jewSoftware: 'https://images.unsplash.com/photo-1611652022419-a9419f74343d?w=800&h=500&fit=crop&q=80',

  // ── Branch cards (700×400 — object-fit:cover at 200px) ──
  branch1: 'https://images.unsplash.com/photo-1612198188060-c7c2a3b66eae?w=700&h=400&fit=crop&q=80',
  branch2: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=700&h=400&fit=crop&q=80',

  // ── Contact page (800×500 — object-fit:cover at 250px) ──
  contactImg: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&h=500&fit=crop&q=80',

  // ── CTA Banners (1600×700 — full-width panoramic at 340px) ──
  ctaWarehouse: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=1600&h=700&fit=crop&q=75',
  ctaLabels: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1600&h=700&fit=crop&q=75',
  ctaRibbons: 'https://images.unsplash.com/photo-1612198188060-c7c2a3b66eae?w=1600&h=700&fit=crop&q=75',
  ctaPrinter: 'https://images.unsplash.com/photo-1544725176-7c40e5a71c5e?w=1600&h=700&fit=crop&q=75',
  ctaScanner: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=1600&h=700&fit=crop&q=75',
  ctaJewellery: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=1600&h=700&fit=crop&q=75',
  ctaTaffeta: 'https://images.unsplash.com/photo-1558769132-cb1aea458c5e?w=1600&h=700&fit=crop&q=75',
  ctaPOS: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=1600&h=700&fit=crop&q=75',
  ctaOffice: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=1600&h=700&fit=crop&q=75',
  ctaAMC: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=1600&h=700&fit=crop&q=75',
  ctaManuf: 'https://images.unsplash.com/photo-1553413077-190dd305871c?w=1600&h=700&fit=crop&q=75',
  ctaSoftware: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1600&h=700&fit=crop&q=75',
  ctaBranches: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=1600&h=700&fit=crop&q=75',
  ctaIndustry: 'https://images.unsplash.com/photo-1553413077-190dd305871c?w=1600&h=700&fit=crop&q=75',

  // ── Subcategory detail cards (600×350 — object-fit:cover at 150px) ──
  thermalDirect: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=350&fit=crop&q=80',
  polyester: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=600&h=350&fit=crop&q=80',
  polypropylene: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=350&fit=crop&q=80',
  voidLabel: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=600&h=350&fit=crop&q=80',
  freezerLabel: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=350&fit=crop&q=80',
  colorRibbon: 'https://images.unsplash.com/photo-1612198188060-c7c2a3b66eae?w=600&h=350&fit=crop&q=80',
  metallicRibbon: 'https://images.unsplash.com/photo-1611652022419-a9419f74343d?w=600&h=350&fit=crop&q=80',
  mobilePrinter: 'https://images.unsplash.com/photo-1544725176-7c40e5a71c5e?w=600&h=350&fit=crop&q=80',
  scanner2d: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=600&h=350&fit=crop&q=80',
  wirelessScanner: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=600&h=350&fit=crop&q=80',
  presentScanner: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&h=350&fit=crop&q=80',
  indScanner: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=600&h=350&fit=crop&q=80',
  longRange: 'https://images.unsplash.com/photo-1553413077-190dd305871c?w=600&h=350&fit=crop&q=80',
  jewStringTag: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=600&h=350&fit=crop&q=80',
  jewAdhesive: 'https://images.unsplash.com/photo-1611652022419-a9419f74343d?w=600&h=350&fit=crop&q=80',
  jewPlain: 'https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=600&h=350&fit=crop&q=80',
  wovenLabel: 'https://images.unsplash.com/photo-1558769132-cb1aea458c5e?w=600&h=350&fit=crop&q=80',
  satinLabel: 'https://images.unsplash.com/photo-1489987707025-afc232f7ea0f?w=600&h=350&fit=crop&q=80',
  careLabel: 'https://images.unsplash.com/photo-1558769132-cb1aea458c5e?w=600&h=350&fit=crop&q=80',
  hangTag: 'https://images.unsplash.com/photo-1558769132-cb1aea458c5e?w=600&h=350&fit=crop&q=80',
  receiptPrinter: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&h=350&fit=crop&q=80',
  cashDrawer: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&h=350&fit=crop&q=80',

} as const;

export const TICKER_ITEMS: string[] = [
  'Thermal Barcode Label Rolls', 'Zebra ZD230 Desktop Printer', 'Wax Resin TTR Ribbons',
  'Jewellery Barcode Price Tags', '2D QR Code Scanners', 'Retail POS Billing System',
  'Taffeta Woven Labels', 'Full Resin Ribbons', 'Honeywell Industrial Printer',
];

export const BRANDS: string[] = ['Zebra Technologies', 'Honeywell', 'TSC Printers', 'Datalogic', 'Postek'];

export const HOME_STATS = [
  { number: '500+', label: 'Satisfied Clients', sub: 'Across Uttarakhand & India' },
  { number: '10+', label: 'Years Experience', sub: 'Specialized barcode solutions' },
  { number: '7', label: 'Product Categories', sub: 'Labels, printers, scanners & POS' },
  { number: '24/7', label: 'Customer Support', sub: 'Remote & on-site assistance' },
] as const;
